import React from "react";

import { dispatchAnalyticsTrack } from "~/lib/segment";

import { AuthBase } from "../AuthBase";
import { Button } from "../components/";
import { WhitelabelPane } from "../panes";
import type { AuthProps } from "../types";

import styles from "../css/Auth.module.css";

interface AliasState {
	errorMessage: string | undefined;
}

export default class Alias extends AuthBase<AuthProps, AliasState> {
	documentTitle = "Alias";

	state: AliasState = {
		errorMessage: undefined,
	};

	getPaneComponent() {
		return WhitelabelPane;
	}

	getPaneProps() {
		return { bgStyle: "slash" as const };
	}

	aliasEmail = (): void => {
		const { invite } = window.INITIAL_STATE;
		const oauthEmail = this.props.location.state?.oauth_email; // eslint-disable-line camelcase
		const signedOauthEmail = this.props.location.state?.signed_oauth_email; // eslint-disable-line camelcase

		if (!invite) return;

		const analyticsData = { feature: "Authentication" };

		fetch("/auth/alias/", {
			method: "POST",
			body: JSON.stringify({
				oauthEmail,
				signedOauthEmail,
				inviteCode: invite.code,
			}),
			headers: {
				"x-client-session-id": window.CLIENT_SESSION_ID,
				"x-csrftoken": window.CSRF_TOKEN,
				"x-requested-with": "XMLHttpRequest",
			},
		})
			.then((res: Response) => {
				return res.json();
			})
			.then(() => {
				dispatchAnalyticsTrack("Email Alias Step Completed", analyticsData);
				return this.props.history.push("/auth/signup/", {
					...this.props.location.state,
					message: "Your invitation has been updated, please login again.",
				});
			})
			.catch(() => {
				dispatchAnalyticsTrack("Email Alias Step Failed", analyticsData);
				return this.props.history.push("/auth/signup/", {
					...this.props.location.state,
					message: "Your invitation failed to update, please contact support.",
				});
			});
	};

	renderStep() {
		const { invite } = window.INITIAL_STATE;
		const oauthEmail = this.props.location.state?.oauth_email; // eslint-disable-line camelcase

		return (
			<div className={styles.authFlex}>
				<h2>The invite used doesn&rsquo;t match your email address</h2>
				<h5>
					Is <em>{oauthEmail}</em> an alias for <strong>{invite?.recipient.email}</strong>?
				</h5>

				<div className={styles.authFormNav}>
					<Button onClick={this.navigateTo("/")}>No</Button>

					<Button color="teal" onClick={this.aliasEmail}>
						Yes
					</Button>
				</div>
			</div>
		);
	}
}
